import React from 'react';
import { motion } from 'framer-motion';
import { SnowflakeIcon, GlobeIcon, LineChartIcon, UsersIcon, LayoutTemplateIcon, BellIcon } from 'lucide-react';
const features = [{
  icon: <SnowflakeIcon className="w-6 h-6 text-glacier" data-id="element-11" />,
  title: 'Frost Trigger Engine',
  description: 'Automatically deploy campaigns when temperature thresholds are crossed in target regions.'
}, {
  icon: <GlobeIcon className="w-6 h-6 text-glacier" data-id="element-12" />,
  title: 'Meridian Scheduler',
  description: 'Coordinate launch windows across 140+ climate zones with precision timing.'
}, {
  icon: <LineChartIcon className="w-6 h-6 text-glacier" data-id="element-13" />,
  title: 'Glacial Analytics',
  description: 'Weather-correlated performance dashboards that isolate seasonal impact from baseline metrics.'
}, {
  icon: <UsersIcon className="w-6 h-6 text-glacier" data-id="element-14" />,
  title: 'Boreal Audience Sync',
  description: 'Dynamic audience segmentation based on real-time local weather conditions.'
}, {
  icon: <LayoutTemplateIcon className="w-6 h-6 text-glacier" data-id="element-15" />,
  title: 'Permafrost Templates',
  description: 'Pre-built seasonal campaign frameworks for cold-weather verticals: apparel, energy, travel, F&B.'
}, {
  icon: <BellIcon className="w-6 h-6 text-glacier" data-id="element-16" />,
  title: 'Aurora Notifications',
  description: 'Real-time alerts when weather windows open in your target markets.'
}];
export function Features() {
  return <section id="platform" className="py-24 px-6 relative z-10 bg-navy-light/30 border-y border-white/5" data-id="element-17">
      <div className="container mx-auto max-w-7xl" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-19">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-glacier/10 border border-glacier/20 text-glacier text-sm font-medium mb-4" data-id="element-20">
            Platform Capabilities
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-21">
            Engineered for the Elements
          </h2>
          <p className="text-white/60 max-w-2xl text-lg" data-id="element-22">
            A complete toolkit designed specifically for seasonal agility. Stop
            reacting to the weather and start anticipating it.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-23">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-panel p-8 rounded-2xl hover:bg-glass-gradient-hover transition-all duration-300 group border-t-glacier/30" data-id="element-24">
              <div className="w-12 h-12 rounded-full bg-glacier/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-25">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-frost mb-3" data-id="element-26">
                {feature.title}
              </h3>
              <p className="text-white/60 leading-relaxed text-sm" data-id="element-27">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}